import React from 'react'
import NotificationsTable from '../components/NotificationsTable'

export default props => (
  <NotificationsTable className="container-fluid notifications-page" user={props.user} />
)
